export default "__VITE_ASSET__DHNvrX_T__"